<template>
    <div class="editor-wrapper">
        <el-upload :action="uploadMinioUrl" :before-upload="handleBeforeUpload" :on-success="handleUploadSuccess"
                   :on-error="handleUploadError" name="file" :show-file-list="false" :headers="headers"
                   style="display: none"
                   ref="upload" v-if="this.type === 'url'">
        </el-upload>
        <div class="editor" ref="editor" :style="styles"></div>
        <div class="action-bar">
            <div class="action-alert">{{ alertText }}</div>
            <div class="action-draft" @click="toDraft()">草稿箱</div>
            <div class="action-publish" @click="toPublish()">发布</div>
        </div>
        <div class="tags-bar">
            <el-select v-model="dataType" placeholder="请选择考试类型" style="margin-right: 20px">
                <el-option
                    v-for="(item, index) in dataTypes"
                    :key="'dataType' + index"
                    :label="item.name"
                    :value="item.value"
                >
                </el-option>
            </el-select>
            <el-select v-model="areaValue" placeholder="请选择分享适用区域">
                <el-option v-for="item in areaList" :key="item.areaId" :label="item.content" :value="item.areaId">
                </el-option>
            </el-select>
            <el-select class="tag-select" filterable remote :remote-method="getTagList" :focus="getTagList"
                       @change="handleCorrect" v-model="tagValue" placeholder="请搜索添加分享标签" :loading="loading">
                <el-option v-for="item in tagList" :key="item.tagId" :label="item.name" :value="item">
                </el-option>
            </el-select>
            <div class="tag-list">
        <span class="meta-item__tag" v-for="tag in selectedTagList" :key="tag.tagId">{{ tag.name }}
          <i class="el-icon-circle-close" @click="handleDeleteTag(tag)"></i>
        </span>
            </div>
        </div>
        <div class="title">
            <input type="text" placeholder="请输入标题" @input="handleSave" v-model="title" maxlength="100">
        </div>
    </div>
</template>

<script>
import Quill from "quill";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import {getToken} from "@/utils/auth";
import {getAreaList, getTagList, insertArticleDraft, updateArticleDraft, deleteArticleDraft, insertArticle, getArtileDraftList, uploadMinioUrl} from '@/api';

export default {
    name: "Editor",
    props: {
        /* 编辑器的内容 */
        value: {
            type: String,
            default: "",
        },
        /* 高度 */
        height: {
            type: Number,
            default: null,
        },
        /* 最小高度 */
        minHeight: {
            type: Number,
            default: null,
        },
        /* 只读 */
        readOnly: {
            type: Boolean,
            default: false,
        },
        /* 上传文件大小限制(MB) */
        fileSize: {
            type: Number,
            default: 5,
        },
        /* 类型（base64格式、url格式） */
        type: {
            type: String,
            default: "url",
        },
    },
    data() {
        return {
            dataType: 0,
            dataTypes: [
                {name: '公务员考试', value: 0},
                {name: '事业单位考试', value: 1}
            ],
            title: "",
            tagValue: null,
            areaList: [],
            tagList: [],
            loading: false,
            selectedTagList: [],
            areaValue: null,
            alertText: "文章将自动保存至草稿箱",
            uploadMinioUrl,
            headers: {
                Authorization: "Bearer " + getToken()
            },
            draftId: null,
            articleId: null,
            Quill: null,
            currentValue: "",
            options: {
                theme: "snow",
                bounds: document.body,
                debug: "warn",
                modules: {
                    // 工具栏配置
                    toolbar: [
                        ["bold", "italic", "underline", "strike"],       // 加粗 斜体 下划线 删除线
                        [{list: "ordered"}, {list: "bullet"}],       // 有序、无序列表
                        [{header: [1, 2, 3, false]}],         // 标题
                        [{color: []}, {background: []}],             // 字体颜色、字体背景颜色                            // 对齐方式
                        ["clean"],                                       // 清除文本格式
                        ["image"]                       // 链接、图片、视频
                    ],
                },
                placeholder: "请输入正文内容",
                readOnly: this.readOnly,
            },
        };
    },
    computed: {
        styles() {
            let style = {};
            if (this.minHeight) {
                style.minHeight = `${this.minHeight}px`;
            }
            if (this.height) {
                style.height = `${this.height}px`;
            }
            return style;
        },
    },
    watch: {
        dataType: {
            async handler(newVal) {
                await this.getAreaList(newVal);
                this.areaValue = null;
                this.handleSave();
            },
            deep: true
        },
        areaValue: {
            handler(newVal) {
                this.handleSave();
            },
            deep: true
        },
        value: {
            handler(val) {
                if (val) {
                    this.handleSave();
                }
            },
            immediate: true,
        },
    },
    created() {
        this.dataType = this.$store.getters["user/getState"].dataType;
        this.$store.dispatch('category/GetAreaList').then(() => {
            this.areaValue = localStorage.getItem('selectedAreaId') ? Number(localStorage.getItem('selectedAreaId')) : null;
            // 获取区域列表
            const originalAreaList = this.$store.getters["category/getState"].areaCategoryList;
            // 添加"所有省份"选项作为第一个选项
            this.areaList = [
                { areaId: null, content: '所有省份' },
                ...originalAreaList
            ];
        });
        if(this.$route.path.indexOf("draft") > 0) {
            this.draftId = this.$route.params.id;
            this.getDraftList()
        }
    },
    mounted() {
        this.init();
    },
    beforeDestroy() {
        this.Quill = null;
    },
    methods: {
        async getAreaList(dataType) {
            let response = await getAreaList({
                    page: 1,
                    pageSize: 1000,
                    dataType: dataType
            });
            // 添加"所有省份"选项作为第一个选项，无论是公务员考试还是事业单位考试
            this.areaList = [
                { areaId: null, content: '所有省份' },
                ...response.rows
            ];
        },
        // 获取草稿箱数据
        getDraftList() {
            getArtileDraftList({
                draftId: this.draftId,
                pageNum: 1,
                pageSize: 10,
            }).then((res) => {
                let data = res.rows[0]
                this.dataType = data.dataType
                this.areaValue = data.areaId
                this.selectedTagList = data.tags;
                this.title = data.title
                this.currentValue = data.descContent
                this.Quill.pasteHTML(this.currentValue)
            });
        },
        init() {
            const editor = this.$refs.editor;
            this.Quill = new Quill(editor, this.options);
            // 如果设置了上传地址则自定义图片上传事件
            if (this.type === 'url') {
                let toolbar = this.Quill.getModule("toolbar");
                toolbar.addHandler("image", (value) => {
                    if (value) {
                        this.$refs.upload.$children[0].$refs.input.click();
                    } else {
                        this.quill.format("image", false);
                    }
                });
            }
            this.Quill.pasteHTML(this.currentValue);
            this.Quill.on("text-change", (delta, oldDelta, source) => {
                const html = this.$refs.editor.children[0].innerHTML;
                const text = this.Quill.getText();
                const quill = this.Quill;
                this.currentValue = html;
                this.$emit("input", html);
                this.$emit("on-change", {html, text, quill});
                
                // 确保光标可见
                this.ensureCursorVisible();
            });
            this.Quill.on("text-change", (delta, oldDelta, source) => {
                this.$emit("on-text-change", delta, oldDelta, source);
            });
            this.Quill.on("selection-change", (range, oldRange, source) => {
                this.$emit("on-selection-change", range, oldRange, source);
                
                // 当选择区域变化时确保光标可见
                if (range) {
                    this.ensureCursorVisible();
                }
            });
            this.Quill.on("editor-change", (eventName, ...args) => {
                this.$emit("on-editor-change", eventName, ...args);
            });

            // 处理粘贴事件，将粘贴的图片上传到服务器
            this.Quill.clipboard.addMatcher(Node.ELEMENT_NODE, (node, delta) => {
                if (node.tagName === 'IMG' && node.src && node.src.startsWith('data:')) {
                    // 如果是base64图片，上传到服务器
                    this.uploadBase64Image(node.src);
                    return { ops: [] }; // 返回空操作，阻止插入base64图片
                }
                return delta;
            });

            this.getTagList();
        },
        
        // 确保光标可见
        ensureCursorVisible() {
            this.$nextTick(() => {
                const selection = this.Quill.getSelection();
                if (selection) {
                    // 获取光标位置的坐标
                    const bounds = this.Quill.getBounds(selection.index);
                    if (bounds) {
                        // 获取编辑器容器
                        const editorContainer = this.$refs.editor;
                        if (editorContainer) {
                            const containerHeight = editorContainer.clientHeight;
                            const scrollTop = editorContainer.scrollTop;
                            const cursorTop = bounds.top;
                            
                            // 只有当光标完全不可见时才调整滚动位置
                            if (cursorTop < 0) {
                                // 光标在可视区域上方
                                editorContainer.scrollTop = scrollTop + cursorTop - 50;
                            } else if (cursorTop > containerHeight - 50) {
                                // 光标在可视区域下方
                                editorContainer.scrollTop = scrollTop + cursorTop - containerHeight + 100;
                            }
                        }
                    }
                }
            });
        },

        // 上传前校检格式和大小
        handleBeforeUpload(file) {
            const type = ["image/jpeg", "image/jpg", "image/png", "image/svg"];
            const isJPG = type.includes(file.type);
            // 检验文件格式
            if (!isJPG) {
                this.$message.error(`图片格式错误!`);
                return false;
            }
            // 校检文件大小
            if (this.fileSize) {
                const isLt = file.size / 1024 / 1024 < this.fileSize;
                if (!isLt) {
                    this.$message.error(`上传文件大小不能超过 ${this.fileSize} MB!`);
                    return false;
                }
            }
            return true;
        },

        handleUploadSuccess(res, file) {
            // 如果上传成功
            if (res.code === 200) {
                // 获取富文本组件实例
                let quill = this.Quill;
                // 获取光标所在位置
                let length = quill.getSelection().index;
                // 插入图片  res.url为服务器返回的图片地址
                quill.insertEmbed(length, "image", res.url);
                // 调整光标到最后
                quill.setSelection(length + 1);
            } else {
                this.$message.error("图片插入失败");
            }
        },

        handleUploadError() {
            this.$message.error("图片插入失败");
        },

        // 上传base64图片
        uploadBase64Image(base64Data) {
            // 将base64转换为文件对象
            const byteString = atob(base64Data.split(',')[1]);
            const mimeString = base64Data.split(',')[0].split(':')[1].split(';')[0];
            const ab = new ArrayBuffer(byteString.length);
            const ia = new Uint8Array(ab);
            for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            const blob = new Blob([ab], { type: mimeString });
            const file = new File([blob], `pasted-image-${Date.now()}.${mimeString.split('/')[1]}`, { type: mimeString });

            // 检查文件格式和大小
            if (!this.handleBeforeUpload(file)) {
                return;
            }

            // 创建FormData并上传
            const formData = new FormData();
            formData.append('file', file);

            // 使用fetch上传文件
            fetch(this.uploadMinioUrl, {
                method: 'POST',
                headers: this.headers,
                body: formData
            })
            .then(response => response.json())
            .then(res => {
                if (res.code === 200) {
                    // 获取当前光标位置
                    const selection = this.Quill.getSelection();
                    const index = selection ? selection.index : this.Quill.getLength();

                    // 插入图片
                    this.Quill.insertEmbed(index, "image", res.url);
                    // 调整光标到图片后面
                    this.Quill.setSelection(index + 1);
                } else {
                    this.$message.error("图片上传失败");
                }
            })
            .catch(error => {
                console.error('上传失败:', error);
                this.$message.error("图片上传失败");
            });
        },

        toDraft() {
            this.$router.push('/community/draft');
        },

        async toPublish(hash = '') {
            if(!this.title || !this.title.trim()) {
                this.$message.warning('请输入标题, 再进行发布！');
                return;
            }
            let data = {
                dataType: this.dataType,
                areaId: this.areaValue,
                title: this.title,
                descContent: this.currentValue,
                tagList: this.selectedTagList
            }
            let res = await insertArticle(data);
            this.articleId = res.data.articleId;
            if (this.articleId) {
                this.$message.success('发布成功');
                await this.$router.push('/community/published');
            }
            if(this.draftId) {
                this.delArticleDraft(this.draftId);
            }
        },

        handleCorrect(val) {
            if (this.selectedTagList.length > 2) {
                this.$message.warning('最多只能选择三个标签');
                this.tagValue = '';
                return;
            }
            if (this.selectedTagList.some(tag => tag.tagId === this.tagValue.tagId)) {
                this.$message.warning('标签已存在');
                this.tagValue = '';
                return;
            }
            this.selectedTagList.push(this.tagValue);
            this.tagValue = '';
        },

        getTagList(query) {
            this.loading = true;
            let params = {};
            if (query) {
                params.name = query;
            }
            getTagList(params).then(response => {
                this.tagList = response.rows;
                this.loading = false;
            });
        },

        handleDeleteTag(tag) {
            let index = this.selectedTagList.indexOf(tag);
            if (index > -1) {
                this.selectedTagList.splice(index, 1);
            }
        },

        handleSave() {
            // 防抖处理：仅在最后一次调用后的延迟时间内执行
            clearTimeout(this.saveTimer); // 清除上一个定时器
            this.alertText = '正在保存中...';
            this.saveTimer = setTimeout(() => {
                this.alertText = '保存成功';
                if (this.draftId) {
                    this.updateDraft();
                } else {
                    this.insertDraft();
                }
            }, 1000);
        },

        async insertDraft() {
            let data = {
                dataType: this.dataType,
                areaId: this.areaValue,
                title: this.title,
                descContent: this.currentValue,
                tagList: this.selectedTagList
            }
            let response = await insertArticleDraft(data);
            this.draftId = response.data.draftId;
        },

        async updateDraft() {
            let data = {
                draftId: this.draftId,
                articleId: this.articleId,
                dataType: this.dataType,
                areaId: this.areaValue,
                title: this.title,
                descContent: this.currentValue,
                tagList: this.selectedTagList
            }
            await updateArticleDraft(data);
        },

        delArticleDraft(draftId) {
            deleteArticleDraft(draftId).then(res => {
                
            })
        },
    },
};
</script>

<style>
.editor-wrapper {
    position: relative !important;
}

.editor,
.ql-toolbar {
    white-space: pre-wrap !important;
    line-height: normal !important;
    border: none !important;

}

.editor {
    margin-top: 100px;
    position: relative;
    max-height: calc(100vh - 300px);
    overflow-y: auto;
    font-size: 16px;
}

/* 添加一个伪元素，在编辑器内容后添加足够的空白区域 */
.ql-container:after {
    content: '';
    display: block;
    height: 50vh; /* 添加视窗高度的一半作为空白区域 */
    width: 100%;
}

.ql-toolbar {
    border-bottom: 1px solid #E6E6E6 !important;
}

.quill-img {
    display: none;
}

.ql-snow {
    padding: 0px 0px 16px 0px !important;
}

.ql-snow .ql-tooltip[data-mode="link"]::before {
    content: "请输入链接地址:";
}

.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
    border-right: 0px;
    content: "保存";
    padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode="video"]::before {
    content: "请输入视频地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
    content: "14px";
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="small"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="small"]::before {
    content: "10px";
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="large"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="large"]::before {
    content: "18px";
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="huge"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="huge"]::before {
    content: "32px";
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
    content: "文本";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
    content: "标题1";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
    content: "标题2";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
    content: "标题3";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
    content: "标题4";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
    content: "标题5";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
    content: "标题6";
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
    content: "标准字体";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
    content: "衬线字体";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
    content: "等宽字体";
}

.editor-wrapper > .action-bar {
    position: absolute;
    top: 0px;
    right: 0px;
    display: flex;
    z-index: 800;
    background: white;
}

.editor-wrapper > .action-bar > .action-draft,
.action-publish {
    padding: 0 20px;
    border-radius: 5px;
    line-height: 28px;
    cursor: pointer;
}

.editor-wrapper > .action-bar > .action-draft {
    border: 1px solid #46B4B1;
    color: #46B4B1;
    margin-right: 20px;
}

.editor-wrapper > .action-bar > .action-publish {
    background-color: #46B4B1;
    color: #FFF;
}

.editor-wrapper > .action-bar > .action-alert {
    color: #E1F4F4;
    line-height: 28px;
    padding: 0 20px;
    color: #D9D9D9;
}

.editor-wrapper > .tags-bar {
    position: absolute;
    top: 50px;
    left: 0px;
    display: flex;
    z-index: 800;
    background: white;
}

.editor-wrapper > .tags-bar > .tag-select {
    margin: 0 20px 0 32px;
}

.editor-wrapper > .tags-bar > .tag-list {
    display: flex;
}

.editor-wrapper > .tags-bar > .tag-list > .meta-item__tag {
    cursor: pointer;
    background-color: #E1F4F4;
    color: #46B4B1;
    margin-right: 8px;
    padding: 2px 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: var(----semi-border-radius-extra-small, 3px);
}

.editor-wrapper > .tags-bar > .tag-list > .meta-item__tag > .el-icon-circle-close {
    margin-left: 8px;
}

.el-input__inner {
    height: 28px !important;
    line-height: 28px !important;
    font-size: 12px;
    background-color: #F2F3F5 !important;
    border: none !important;
}

.el-input__inner:focus {
    border-color: #46B4B1 !important;
}

.el-select-dropdown__item.selected {
    color: #46B4B1 !important;
}

.el-input__icon {
    line-height: 28px !important;
}

.editor-wrapper > .title {
    position: absolute;
    top: 100px;
    width: 100%;
}

.editor-wrapper > .title > input {
    font-size: 24px;
    font-weight: 500;
    width: 100%;
}
</style>
